import { render, staticRenderFns } from "./AppScreen.vue?vue&type=template&id=b33d8986&"
import script from "./AppScreen.vue?vue&type=script&lang=js&"
export * from "./AppScreen.vue?vue&type=script&lang=js&"
import style0 from "./AppScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports